import { get } from "lodash";
import { useState } from "react";
import arrowDropDownIcon from "../../../../Assets/icons/arrow_drop_down.svg";
import ProfileModal from "./Modal";

function Profile({ project, updateStatus }) {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  const firstname = get(project, "contact.user.firstname", "");
  const lastname = get(project, "contact.user.lastname", "");
  const displayName = `${firstname} ${lastname}`.trim() || "";

  if (!displayName) return null;

  return (
    <>
      <button type="button" className="acoris-navbar__profile" onClick={onOpen}>
        <span>{displayName}</span>
        <img
          src={arrowDropDownIcon}
          alt=""
          className="acoris-navbar__profile-arrow"
        />
      </button>
      <ProfileModal
        open={open}
        updateStatus={updateStatus}
        onClose={onClose}
        project={project}
      />
    </>
  );
}

export default Profile;
